var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F1F5F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2632_2814",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2632_2814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 30C20.45 30 19.9792 29.8042 19.5875 29.4125C19.1958 29.0208 19 28.55 19 28V16C19 15.45 19.1958 14.9792 19.5875 14.5875C19.9792 14.1958 20.45 14 21 14H30C30.55 14 31.0208 14.1958 31.4125 14.5875C31.8042 14.9792 32 15.45 32 16V28C32 28.55 31.8042 29.0208 31.4125 29.4125C31.0208 29.8042 30.55 30 30 30H21ZM17 34C16.45 34 15.9792 33.8042 15.5875 33.4125C15.1958 33.0208 15 32.55 15 32V19C15 18.7167 15.0958 18.4792 15.2875 18.2875C15.4792 18.0958 15.7167 18 16 18C16.2833 18 16.5208 18.0958 16.7125 18.2875C16.9042 18.4792 17 18.7167 17 19V32H27C27.2833 32 27.5208 32.0958 27.7125 32.2875C27.9042 32.4792 28 32.7167 28 33C28 33.2833 27.9042 33.5208 27.7125 33.7125C27.5208 33.9042 27.2833 34 27 34H17Z",
    fill: "#64748B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopy);
export default __webpack_public_path__ + "static/media/ic_copy.23b31375b2c8f8df3ef92ae939c34dda.svg";
export { ForwardRef as ReactComponent };